import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'img[appImgFallback]'
})
export class ImgFallbackDirective {
    @Input() appImgFallback!: string;

    constructor(private readonly el: ElementRef<HTMLImageElement>) { }

    @HostListener('error')
    onError(): void {
        const img = this.el.nativeElement;
        if (img.src !== this.appImgFallback) {
            img.src = this.appImgFallback;
        }
    }
}
